import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import {Card, CardActions, CardHeader,CardTitle, CardText } from 'material-ui/Card';
import Divider from 'material-ui/Divider';

import {createEvent, deleteEvent, loadEventsFromFirebase} from './schedule_actions';
import CreateEvent from './schedule_create';

class Schedule extends Component {
  constructor(props) {
  super(props);
  this.state = {
    open: false,
    };
  }

  componentDidMount() {
    this.props.loadEventsFromFirebase();
  }

  handleOpen = () => {
  this.setState({open: true});
  };

  handleClose = () => {
  this.setState({open: false});
  };

   buttonActions = () => {
      return (
      <div>
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />
        <FlatButton
          label="Submit"
          primary={true}
          onClick={() => console.log('Event Created')}
        />
      </div>
    )
  }

  eventList = () => {
    return Object.values(this.props.allEvents).map((event) => {
      return(
        <Col key={event.key} xs={12} sm={12} md={12}>
          <Card style={{ marginTop: 15, backgroundColor: '#FAFAFA', marginLeft: -25, marginRight: -25 }} initiallyExpanded={false}>
             <CardHeader
               title={event.event}
               titleStyle={{ color: 'black', fontSize: 20 }}
               subtitle={event.datetime}
               subtitleStyle={{ fontSize: 11.5}}
               actAsExpander={true}
               showExpandableButton={true}
             />
           <Divider />
            <CardText expandable={true}>
              <Row>
                <Col  xs={12} sm={12} md={12} lg={12}>
                  <Card style={{ marginTop: 5 }}>
                    <CardTitle title="Notes" subtitle={event.details} titleStyle={{ fontSize: 20 }} />
                  </Card>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Card style={{ marginTop: 5 }}>
                    <iframe
                      title={'Map'}
                      width={'100%'}
                      height="450"
                      frameBorder="0" style={{ border: 0 }}
                      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCPrnJ0JJj8gaIxgedZqLA3MZHDHXFJfvs
                        &q=${event.location.split(" ").join('+')}`} allowFullScreen>
                    </iframe>
                  </Card>
                </Col>
              </Row>
              <CardActions>
                 <FlatButton label="Delete" onClick={()=>this.props.deleteEvent(event.key)}/>
              </CardActions>
            </CardText>
          </Card>
        </Col>
      )
    })
  }

  render() {
    return (
      <div>
        <Grid fluid style={{ marginBottom: 120, borderRadius: 10 }}>
          <Row>
            {this.eventList()}
          </Row>
        </Grid>

        <FloatingActionButton backgroundColor={'#3F7CAC'}
          style={{
            position: 'fixed',
            bottom: 30,
            right: 20
          }}
          onClick={this.handleOpen}>
          <ContentAdd />
        </FloatingActionButton>

        <Dialog
          title="Create An Event"
          actions={this.buttonActions()}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          <CreateEvent />
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = ({ schedule }) => {
  const { newEvent, allEvents } = schedule;
  return { newEvent, allEvents }
}

export default connect(mapStateToProps, { createEvent, deleteEvent, loadEventsFromFirebase })(Schedule);



// WEBPACK FOOTER //
// ./src/components/schedule/index.js